export class Base64Utils {
    public static serialize(object: unknown | null | undefined): string | null {
        if (!object) {
            return null;
        }

        const json = JSON.stringify(object);
        return this.utf8ToBase64(json);
    }

    public static deserialize(object: string | null | undefined): object {
        if (!object) {
            return {};
        }

        const str = this.base64ToUtf8(object);
        return JSON.parse(str);
    }

    private static utf8ToBase64(str: string): string {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
            return String.fromCharCode(parseInt(p1, 16));
        }));
    }

    private static base64ToUtf8(str: string): string {
        return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
}
